import "core-js/stable";
import "regenerator-runtime/runtime";
import "isomorphic-fetch";

import App from "./App.vue";
import Buefy from "buefy";
import GettyUI from "@thegetty/getty-ui";
import Vue from "vue";
import VueGtm from "vue-gtm";
import VueLazyload from "vue-lazyload";
import VueMeta from "vue-meta";
import filters from "./filters";
import globalRouter from "./router/index";
import goRouter from "./router/go";
import store from "./store";
import configUtil from "./utils/config";
import { getConfig } from "./utils/gtm.config";
import * as Sentry from "@sentry/browser";
import { Vue as VueIntegration } from "@sentry/integrations";
import { Integrations } from "@sentry/tracing";
const { name, version } = require("../package.json");

/**
 * Loads runtime configuration from a JSON file the 'public' directory
 */
const loadConfig = async () => {
  const basePath = process.env.BASE_URL?.replace(/\/$/, "");
  const configFile = `${basePath}/config.json`;
  const config = await fetch(configFile, { cache: "no-store" })
    .then(response => {
      if (!response.ok) throw new Error(response.status);
      return response.json();
    })
    .catch(error => {
      console.error(`Unable to load runtime configuration from ${configFile}`);
    });
  return config;
};

loadConfig().then(json => {
  const runtimeConfig = configUtil(json);
  const isGoEnabled = runtimeConfig.elasticsearch.index === "go";
  let router = globalRouter;
  if (isGoEnabled) {
    router = goRouter;
  }

  Sentry.init({
    dsn: ["prod", "staging"].includes(runtimeConfig.env)
      ? runtimeConfig.sentry.dsn
      : null,
    environment: runtimeConfig.env,
    integrations: [
      new VueIntegration({
        Vue,
        tracing: true,
        tracingOptions: {
          trackComponents: true
        }
      }),
      new Integrations.BrowserTracing()
    ],
    release: `${name}@${version}`,
    tracesSampleRate: 1.0
  });

  Vue.use(Buefy);
  Vue.use(GettyUI);
  Vue.use(VueLazyload);
  Vue.use(VueMeta);
  Vue.use(VueGtm, { ...getConfig(router) });
  Vue.use(filters);

  Vue.config.productionTip = false;

  new Vue({
    router,
    store,
    provide() {
      return { runtimeConfig };
    },
    render: h => h(App)
  }).$mount("#app");
});
